import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { TERMS_AND_CONDITIONS_ACTION_TYPE } from "./terms-and-conditions.action";
import { TermsAndConditionsState } from "./terms-and-conditions.model";

const initialState: TermsAndConditionsState = {};

export function termsAndConditionsReducer(state = initialState, action: ActionWithPayload): TermsAndConditionsState {
	switch (action.type) {
		case TERMS_AND_CONDITIONS_ACTION_TYPE.getHistorySuccess: {
			return updateState(state, {
				history: action.payload,
			});
		}
		case TERMS_AND_CONDITIONS_ACTION_TYPE.getLatestVersionSuccess: {
			return updateState(state, {
				latestVersion: action.payload,
			});
		}
		default:
			return state;
	}
}
